export default {
    entityKey: 'code-pipelines',
    basePath: '/code-pipelines',
    titles: {
        singular: 'Code Pipeline',
        plural: 'Code Pipelines'
    }
}
